// extracted by css-extract-rspack-plugin
export default {"downloadToolbar":"achGS00y58gomUuD","tableWrapper":"Tg1MrIOzdcb9iwV6","totalsRow":"ub6xqE0GvY4FkQYc"};